"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmlsBoxMessage = void 0;
/* eslint-disable sonarjs/no-identical-expressions */
const react_1 = __importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const className_1 = require("../../utils/className");
exports.SmlsBoxMessage = ({ id, children, mode = 'block', style = undefined, className = '', }) => {
    return (react_1.default.createElement(reactstrap_1.Card, { id: id, className: className_1.mapToCssModules(['smls-box-message', className, mode]), style: style },
        react_1.default.createElement(reactstrap_1.CardBody, null,
            react_1.default.createElement("div", { className: "content" }, children),
            react_1.default.createElement("i", { className: "material-icons" }, "close"))));
};
//# sourceMappingURL=index.js.map